<template>
<div>
    <v-btn style="position: absolute;top: 12px;right: 0px;z-index: 4" icon @click="emitClose" color="white" small>
      <v-icon color="primary">close</v-icon>
    </v-btn>
    <div class="top-btns primary pa-2">
      <v-layout row wrap>
        <v-flex xl12 lg12 sm12 xs12>
      <div class="py-2 px-3 c-pointer" :class="(isToDo) ? 'custom-btn custom-btn-width' : 'custom-btn-width'"  @click="renderSelected('to-do')">
    <v-icon color="white">mdi-format-list-checks</v-icon>
    </div>
    <!-- <div class="py-2 px-3 c-pointer" :class="(isEmails) ? 'custom-btn custom-btn-width' : 'custom-btn-width'" @click="renderSelected('emails')">
      <v-icon color="white">fa fa-envelope</v-icon>
      </div> -->
        </v-flex>
       <!-- <v-flex xl6 lg6 sm6 xs6> -->
                 <!-- </v-flex> -->
      </v-layout>
  </div>
  <div style="height:65px;"></div>
  <div v-if="isToDo"  @scroll="check">
    <!-- <global-to-do :toDoCountObj="toDoCountObj"></global-to-do> -->
  </div>
    <div v-if="isEmails">
      <p class="headline" v-if="isEmails">Email</p>
    </div>
  </div>
</template>
<script>
// import GlobalToDo from './globalToDo'
export default {
  props: ['toDoCountObj'],
  components: {
    // GlobalToDo
  },
  data () {
    return {
      isToDo: true,
      isEmails: false
    }
  },
  methods: {
    renderSelected (render) {
      // alert('caleed')
      if (render === 'to-do') {
        this.isToDo = true
        this.isEmails = false
      } else if (render === 'emails') {
        this.isToDo = false
        this.isEmails = true
      }
    },
    check () {
      alert('no')
    },
    emitClose () {
      this.$root.$emit('closeRightDrawerForToDo', false)
    }
  }
}
</script>
<style scoped>
.top-btns{
    position: fixed;
    width:350px;
    height: 65px;
    z-index: 3;
}
@media only screen and (max-width: 600px) {
.top-btns{
    width: 100%;
  }
}
.custom-btn{
  border: 1px solid white;
  /* width: 75%; */
}
.custom-btn-width{
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/view/admin/layout/components/rightTab.vue